import { useCreatePrayerMutation } from "./prayer-api";
import { useAuthUserNavigate } from "@/features/auth";
import { appPaths } from "@/app";
import { PrayerForm } from "./prayer-form";
import { useEffect } from "react";
import { useGetUpcomingSenateMeeting } from "@/features/meetings";
import { BackButton, PageLayout, Section } from "@/features/ui";
import { useLocation } from "react-router-dom";

type PrayerCreateProps = {
    onPrayerCreated?: (data) => void;
    meetingId?: number;
    showBackButton?: boolean;
};

export const PrayerCreate = (props: PrayerCreateProps): React.ReactElement => {
    const { navigateTo } = useAuthUserNavigate();
    const location = useLocation();
    const {
        meetingId,
        onPrayerCreated = () => navigateTo(appPaths.prayers),
        showBackButton = true,
    } = props;

    // Get meeting number from navigation state
    const meetingNumber = location.state?.meetingNumber;

    const [
        initiatePrayerMutation,
        { data, isLoading: isPrayerCreating, isSuccess: isPrayerCreated },
    ] = useCreatePrayerMutation();

    const { meeting } = useGetUpcomingSenateMeeting();

    useEffect(() => {
        if (isPrayerCreated) {
            onPrayerCreated(data);
        }
    }, [isPrayerCreated, onPrayerCreated, data]);

    // Use meetingId from props, or from meeting number, or fallback to upcoming meeting
    const effectiveMeetingId = meetingId ?? (meetingNumber ? parseInt(meetingNumber) : meeting?.id);

    return (
        <PageLayout pageLabel="Create Prayer">
            <Section>
                {showBackButton && <BackButton />}
                <PrayerForm
                    submit={initiatePrayerMutation}
                    isSubmitting={isPrayerCreating}
                    isEdit={false}
                    meetingId={effectiveMeetingId}
                />
            </Section>
        </PageLayout>
    );
};
